import { render, staticRenderFns } from "./inquiryDetailInfo.vue?vue&type=template&id=7a56c20c&scoped=true"
import script from "./inquiryDetailInfo.vue?vue&type=script&lang=js"
export * from "./inquiryDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetailInfo.vue?vue&type=style&index=0&id=7a56c20c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56c20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a56c20c')) {
      api.createRecord('7a56c20c', component.options)
    } else {
      api.reload('7a56c20c', component.options)
    }
    module.hot.accept("./inquiryDetailInfo.vue?vue&type=template&id=7a56c20c&scoped=true", function () {
      api.rerender('7a56c20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/components/inquiryDetailInfo.vue"
export default component.exports